const e = {
  extends: "Cash5",
  logo: !0
};
export {
  e as default
};
